import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SelectInputHelper } from 'src/app/shared/helpers/select-input.helper';
import { SelectInputData } from 'src/app/shared/interfaces/select-input-data.interface';
import { AdminDataService } from 'src/app/view/admin/services/admin.data-service';

/**
 * ! Component is displayed only for superadmins
 */
@Component({
  selector: 'app-company-select',
  templateUrl: './company-select.component.html',
  styleUrls: ['./company-select.component.scss']
})
export class CompanySelectComponent implements OnInit, OnDestroy {
  public companySelect: SelectInputData<string>[] = [];
  public companyControl = new FormControl(null, Validators.required);

  private subscription$ = new Subscription();

  constructor(private dialogRef: MatDialogRef<CompanySelectComponent>, private aDS: AdminDataService) {}

  ngOnInit(): void {
    this.subscription$.add(
      this.aDS
        .getCompanies$()
        .subscribe((companies) => (this.companySelect = SelectInputHelper.fromObjects(companies, 'name', 'id')))
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public submit(): void {
    if (this.companyControl.invalid) {
      this.companyControl.markAsTouched();
      return;
    }
    const companyId = this.companyControl.value;
    this.dialogRef.close(companyId);
  }
}
